import { createAuthConfig } from '@arm/ce-shared-components';
import config from '../temp/config';

/**
 * Builds the MsalAuthentication AuthConfig from the app's REACT_APP_MSAL_* env config.
 * Used by the support-mode login experience and the /login + /auth-callback bridge routes.
 */
const AUTH_ROUTE_SEGMENTS = new Set(['auth-callback', 'login', 'logout', 'front-channel-logout']);

const getBaseRedirectPath = () => {
  const pathname = config.REACT_APP_PATHNAME || '/';
  const normalized = pathname.endsWith('/') && pathname !== '/' ? pathname.slice(0, -1) : pathname;
  return normalized || '/';
};

const isAuthRoutePath = (pathname) =>
  pathname
    .toLowerCase()
    .split('/')
    .some((segment) => AUTH_ROUTE_SEGMENTS.has(segment));

export const getPostAuthRedirectPath = () => {
  if (typeof window === 'undefined') {
    return getBaseRedirectPath();
  }

  const { pathname, search, hash } = window.location;

  if (isAuthRoutePath(pathname)) {
    return getBaseRedirectPath();
  }

  return `${pathname || '/'}${search}${hash}`;
};

export const getMsalAuthConfig = () => {
  return createAuthConfig({
    b2cHost: config.REACT_APP_MSAL_B2C_HOST,
    tenant: config.REACT_APP_MSAL_TENANT,
    b2cPolicy: config.REACT_APP_MSAL_POLICY,
    clientId: config.REACT_APP_MSAL_CLIENT_ID,
    logoutUrl: config.REACT_APP_MSAL_LOGOUT_URL,
    postAuthRedirectPath: getPostAuthRedirectPath(),
    scope: config.REACT_APP_MSAL_SCOPE,
    redirectPath: config.REACT_APP_MSAL_REDIRECT_PATH,
    jwksUri: config.REACT_APP_MSAL_JWKS_URI,
    issuer: config.REACT_APP_MSAL_ISSUER,
  });
};
